const state = {
  selected: {},
  allIrpfReports: [],
  irpfMessage: ''
}
const actions = {
  async getIrpfReportsList({ commit, dispatch, state }, plan) {
    let cpf = plan.beneficiarios[0].cpf
    let _this = this
    let query = {}
    let irpfMessage = '' 
    let allIrpfReports = []

    let obj = {
      url: `/boletos/?tipo=irpf&cpf=${cpf}&ey=${_this.state.ey}`,
      query: query,
      method: 'get',
      api:'irpf'
    }
    await _this.dispatch('request/doRequest', obj).then(resp => {
      if(resp && resp.data.resultado) {
        let paramsList = ['cpf', 'nome','ano', 'operadora', 'entidade', 'proposta', 'codigo']
        resp.data.resultado.map( line => {
          dispatch('convertArryToObject', {line, paramsList}).then( lineObj =>
            allIrpfReports.push(lineObj)
          )
          })
      } else {
        irpfMessage = resp.data.message
      }
    })
    commit('saveIrpfReports', { irpfMessage, allIrpfReports })
    return true
  },
  convertArryToObject( {}, {...params}){
    let obj = params.line.reduce((acum, current, i) => {
        acum[params.paramsList[i]] = current
      return acum
    }, {})
    return obj
  },
}

const mutations = {
  saveIrpfReports: (state, irpf) => {
    console.log(irpf.allIrpfReports)
    if(irpf.irpfMessage){
      state.irpfMessage = irpf.irpfMessage
    }
    if(irpf.allIrpfReports){
      state.allIrpfReports = irpf.allIrpfReports
    }
  }
}

export default {
  namespaced: true,
  root: true,
  actions,
  mutations,
  state
}
